import { cn } from "@/lib/utils";
import type { ParcelStatus } from "@/lib/mock-data";
import { statusLabel, statusTone } from "@/lib/mock-data";

const toneStyles: Record<string, string> = {
  info: "bg-info/10 text-info border-info/20",
  warning: "bg-warning/15 text-warning-foreground border-warning/30",
  success: "bg-success/10 text-success border-success/20",
  destructive: "bg-destructive/10 text-destructive border-destructive/20",
  muted: "bg-muted text-muted-foreground border-border",
};

export function StatusPill({ status, className }: { status: ParcelStatus; className?: string }) {
  const tone = statusTone(status);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        toneStyles[tone],
        className
      )}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          tone === "success" && "bg-success",
          tone === "info" && "bg-info",
          tone === "warning" && "bg-warning",
          tone === "destructive" && "bg-destructive",
          tone === "muted" && "bg-muted-foreground/60"
        )}
      />
      {statusLabel(status)}
    </span>
  );
}
